import { Injectable } from '@angular/core';
import {AppSettings} from "../../proyect.conf";
import { HttpClient } from "@angular/common/http";
import {AutenticacionService} from "./autenticacion.service";
import {map} from "rxjs/operators";
import {PoliticaFlujoVentaPaso} from "../_models/politica-flujo-venta-paso";

@Injectable({
  providedIn: 'root'
})
export class PoliticasFlujoVentaPasosService {
  private rutServicio = AppSettings.rutServiciosPOLITICA + "/api/politicasFlujoVentaPasos";
  constructor(private httpClient: HttpClient, private autServicio: AutenticacionService) { }

  obtenerPorId( idPolitica: string ) {
    return this.httpClient.get( this.rutServicio + '/politica/' + idPolitica ).pipe( map( res => res as PoliticaFlujoVentaPaso[] ) );
  }

  bulk( regActualizar: PoliticaFlujoVentaPaso[] ) {
    regActualizar.map( ( s: PoliticaFlujoVentaPaso ) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httpClient.post( this.rutServicio + '/bulk', regActualizar  ).pipe( map( res => res as any ) );
  }
}
